// src/data/callPlanning.js
// Cold-call planning data from the BidLyzer Taktik-Board (Sales Cockpit xlsx,
// sheets "Ferien & Feiertage" + "Anruf-Timing", Stand 07/2026). School
// vacations ≠ company holidays, but owners of small firms are away far more
// often — availability drops, calling still pays off.

export const STATE_VACATIONS = {
    SN: {
        name: 'Sachsen',
        ranges: [
            ['2026-07-04', '2026-08-14', 'Sommerferien'],
            ['2026-10-12', '2026-10-24', 'Herbstferien'],
            ['2026-12-23', '2027-01-02', 'Weihnachtsferien'],
        ],
        holidays: [['2026-11-18', 'Buß- und Bettag (nur SN — nicht anrufen!)']],
        hint: 'Kernmarkt. Vollstart ab Mo 17.08. Ab Fr 18.12. Jahresend-Modus.',
    },
    ST: {
        name: 'Sachsen-Anhalt',
        ranges: [
            ['2026-07-04', '2026-08-14', 'Sommerferien'],
            ['2026-10-19', '2026-10-30', 'Herbstferien'],
            ['2026-12-21', '2027-01-02', 'Weihnachtsferien'],
        ],
        holidays: [],
        hint: 'Wie Sachsen, ohne Buß- und Bettag.',
    },
    TH: {
        name: 'Thüringen',
        ranges: [
            ['2026-07-04', '2026-08-14', 'Sommerferien'],
            ['2026-10-12', '2026-10-24', 'Herbstferien'],
            ['2026-12-23', '2027-01-02', 'Weihnachtsferien'],
        ],
        holidays: [],
        hint: 'Vollstart ab Mo 17.08.',
    },
    BB: {
        name: 'Brandenburg',
        ranges: [
            ['2026-07-09', '2026-08-22', 'Sommerferien'],
            ['2026-10-19', '2026-10-30', 'Herbstferien'],
            ['2026-12-23', '2027-01-02', 'Weihnachtsferien'],
        ],
        holidays: [],
        hint: 'Vollstart ab Mo 24.08.',
    },
    BE: {
        name: 'Berlin',
        ranges: [
            ['2026-07-09', '2026-08-22', 'Sommerferien'],
            ['2026-10-19', '2026-10-31', 'Herbstferien'],
            ['2026-12-23', '2027-01-02', 'Weihnachtsferien'],
        ],
        holidays: [],
        hint: 'Vollstart ab Mo 24.08.',
    },
    HH: {
        name: 'Hamburg',
        ranges: [
            ['2026-07-09', '2026-08-19', 'Sommerferien'],
            ['2026-10-19', '2026-10-30', 'Herbstferien'],
            ['2026-12-21', '2027-01-01', 'Weihnachtsferien'],
        ],
        holidays: [],
        hint: 'Vollstart ab Do 20.08.',
    },
    NW: {
        name: 'NRW',
        ranges: [
            ['2026-07-20', '2026-09-01', 'Sommerferien'],
            ['2026-10-17', '2026-10-31', 'Herbstferien'],
            ['2026-12-23', '2027-01-06', 'Weihnachtsferien'],
        ],
        holidays: [],
        hint: 'Vollstart ab Mi 02.09.',
    },
    HE: {
        name: 'Hessen',
        ranges: [
            ['2026-06-29', '2026-08-07', 'Sommerferien'],
            ['2026-10-05', '2026-10-17', 'Herbstferien'],
            ['2026-12-23', '2027-01-12', 'Weihnachtsferien'],
        ],
        holidays: [],
        hint: 'Vollstart ab Mo 10.08.',
    },
    BW: {
        name: 'Baden-Württemberg',
        ranges: [
            ['2026-07-30', '2026-09-12', 'Sommerferien'],
            ['2026-10-26', '2026-10-31', 'Herbstferien'],
            ['2026-12-23', '2027-01-09', 'Weihnachtsferien'],
        ],
        holidays: [],
        hint: 'Vollstart erst ab Mo 14.09.',
    },
    BY: {
        name: 'Bayern',
        ranges: [
            ['2026-08-03', '2026-09-14', 'Sommerferien'],
            ['2026-11-02', '2026-11-06', 'Herbstferien'],
            ['2026-11-18', '2026-11-18', 'Buß- und Bettag (schulfrei)'],
            ['2026-12-24', '2027-01-08', 'Weihnachtsferien'],
        ],
        holidays: [],
        hint: 'Vollstart erst ab Di 15.09.',
    },
};

// Weekday call-window quality for Planungs-/Ingenieurbüros & Bau.
// Slots are [from, to, quality, note]; qualities: top > good > ok > weak > avoid.
export const CALL_TIMING = {
    1: [
        ['07:30', '09:00', 'avoid', 'Wochen-/Bauberatung'],
        ['09:00', '11:30', 'ok', 'ok ab ~10:30'],
        ['11:30', '13:30', 'weak', 'Mittag'],
        ['13:30', '16:00', 'good', ''],
        ['16:00', '17:30', 'ok', ''],
    ],
    2: [
        ['07:30', '09:00', 'good', 'GF vor Terminen am Platz'],
        ['09:00', '11:30', 'top', ''],
        ['11:30', '13:30', 'weak', 'Mittag'],
        ['13:30', '16:00', 'top', ''],
        ['16:00', '17:30', 'good', 'Kleinbüro: GF oft allein'],
    ],
    3: [
        ['07:30', '09:00', 'good', ''],
        ['09:00', '11:30', 'top', ''],
        ['11:30', '13:30', 'weak', 'Mittag'],
        ['13:30', '16:00', 'top', ''],
        ['16:00', '17:30', 'good', ''],
    ],
    4: [
        ['07:30', '09:00', 'good', ''],
        ['09:00', '11:30', 'top', ''],
        ['11:30', '13:30', 'weak', 'Mittag'],
        ['13:30', '16:00', 'top', ''],
        ['16:00', '17:30', 'good', ''],
    ],
    5: [
        ['07:30', '09:00', 'good', ''],
        ['09:00', '11:30', 'good', 'bis ~11:30'],
        ['11:30', '13:30', 'avoid', ''],
        ['13:30', '16:00', 'avoid', 'viele Büros zu ab 13–14 Uhr'],
        ['16:00', '17:30', 'avoid', ''],
    ],
};

export const CALL_RULES = [
    'Kernfenster: Di–Do 09:00–11:30 und 13:30–16:00 (höchste Erreichbarkeits- UND Gesprächsquote).',
    '07:30–09:00 = Geheimtipp für Bau/Tiefbau: GF vor der Baustelle im Büro, Sekretariat noch nicht besetzt.',
    'Bei 1–5-Personen-Büros lohnt 16:30–17:30: der Inhaber geht selbst ans Telefon.',
    'Mo vor 10:30 meiden (Wochen-/Baubesprechung), Fr nach 12:00 meiden (Büros schließen).',
    'Pro Nummer 3–4 Versuche über verschiedene Slots, dann 2 Wochen Pause. ~20–30 % Erreichbarkeit pro Versuch ist normal.',
    'Eigene Nummer immer anzeigen (§7 UWG) — unterdrückte Nummern werden kaum abgenommen.',
];

const toMinutes = (hhmm) => Number(hhmm.slice(0, 2)) * 60 + Number(hhmm.slice(3, 5));
const dateKey = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const QUALITY_META = {
    top: { label: 'TOP-Fenster', badge: 'bg-primary text-on-accent' },
    good: { label: 'gutes Fenster', badge: 'bg-emerald-100 text-emerald-700' },
    ok: { label: 'ok', badge: 'bg-slate-100 text-slate-600' },
    weak: { label: 'schwach (Mittag)', badge: 'bg-amber-100 text-amber-800' },
    avoid: { label: 'meiden', badge: 'bg-red-100 text-red-700' },
    off: { label: 'außerhalb der Anrufzeiten', badge: 'bg-slate-100 text-slate-500' },
};

// Current call-window quality with the slot note and end time.
export function currentCallWindow(now = new Date()) {
    const slots = CALL_TIMING[now.getDay()];
    if (!slots) return { quality: 'off', note: 'Wochenende', until: null };
    const minutes = now.getHours() * 60 + now.getMinutes();
    for (const [from, to, quality, note] of slots) {
        if (minutes >= toMinutes(from) && minutes < toMinutes(to)) {
            return { quality, note, until: to };
        }
    }
    return { quality: 'off', note: '', until: null };
}

// Vacation/holiday status of one Bundesland at a date; null when unknown state.
export function vacationStatus(stateCode, now = new Date()) {
    const state = STATE_VACATIONS[stateCode];
    if (!state) return null;
    const key = dateKey(now);
    for (const [holiday, label] of state.holidays) {
        if (key === holiday) return { active: true, label, until: holiday, holiday: true };
    }
    for (const [from, to, label] of state.ranges) {
        if (key >= from && key <= to) return { active: true, label, until: to, holiday: false };
    }
    return { active: false };
}

// All states currently in vacation, for the banner.
export function activeVacations(now = new Date()) {
    return Object.entries(STATE_VACATIONS)
        .map(([code, state]) => ({ code, name: state.name, status: vacationStatus(code, now) }))
        .filter((s) => s.status?.active);
}
